import React, { memo, useRef } from "react";
import useOutsideDetector from "../../hooks/useOutsideDetector";

const Float = ({ children, onOutsideClick = () => {} }) => {
     const elementRef = useRef(null);

     useOutsideDetector(elementRef, onOutsideClick);

     return (
          <div ref={elementRef} className="position-absolute top-100 left-0" style={{ width: "100%", zIndex: 10 }}>
               {children}
          </div>
     );
};

export default memo(Float);
